import { render, staticRenderFns } from "./repairDetailList.vue?vue&type=template&id=5ff4da47&scoped=true"
import script from "./repairDetailList.vue?vue&type=script&lang=js"
export * from "./repairDetailList.vue?vue&type=script&lang=js"
import style0 from "./repairDetailList.vue?vue&type=style&index=0&id=5ff4da47&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ff4da47",
  null
  
)

export default component.exports